import React from 'react';
import { QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import CheckBox from '../CheckBox';

export type CompliancePermissionsFormFields = {
  canAccessCompliance: boolean;
};

const CompliancePermissions = () => {
  const { t } = useTranslation();
  return (
    <QStack direction={['column']}>
      <CheckBox
        data-cy="permission-checkbox"
        name="canAccessCompliance"
        label="compliance access"
        text={t('forms.permissions.accessCompliance')}
      />
    </QStack>
  );
};

export default CompliancePermissions;
